module.exports = __webpack_public_path__ + "assets/img/logitech-landingpage-and-website-internal-w540.25800f48.jpg";